import { render } from "./PapersList.vue?vue&type=template&id=fcc9f846&scoped=true"
import script from "./PapersList.vue?vue&type=script&lang=js"
export * from "./PapersList.vue?vue&type=script&lang=js"

import "./PapersList.vue?vue&type=style&index=0&id=fcc9f846&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fcc9f846"]])

export default __exports__